import { AnyAction } from "redux";

export const SET_ASSIGNED_RATERS = "SET_ASSIGNED_RATERS";

export const setAssignedRaters =
  data =>
  (dispatch, getState): AnyAction => {
    // const { assignedRaters } = getState().EditPositionReducer;
    return dispatch({ type: SET_ASSIGNED_RATERS, value: data });
  };
